/******/// webpackBootstrap
window.videoPlayers = [];
((_) => { 
  var __webpack_exports__ = {};
  Shopify.theme.jsSlideshowWithText = {
    init: function($section) {
      this.section = $section;
      // Add settings from schema to current object
      Shopify.theme.jsSlideshowWithText = $.extend(this, Shopify.theme.getSectionData($section));

      const textTransition = this.text_transition;
      
      // Selectors
      const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
      const $textSlideshowEl = $section.find('[data-text-slideshow]').removeClass('is-hidden');
      this.initVideo();
      const $imageSlideshow = $imageSlideshowEl.flickity({
        contain: true,
        wrapAround: true,
        adaptiveHeight: false,
        prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
        pageDots: false,
        draggable: true,
        imagesLoaded: true,
        fade: this.image_transition == 'fade' ? true : false,
        autoPlay: this.image_slideshow_speed * 1000,
        arrowShape: arrowShape
      });
      const $textSlideshow = $textSlideshowEl.flickity({
        autoplay: false,
        contain: true,
        imagesLoaded: true,
        lazyload: 4,
        prevNextButtons: false,
        pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
        draggable: false,
        on: {
          ready: function() {
            const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
            Shopify.theme.animation.slideTransition($currentTextSlide, textTransition);
          }
        }
      });
      $imageSlideshow.on('change.flickity', function(event, index) {
        $textSlideshow.flickity('select', index, true, true);

        const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
        Shopify.theme.animation.slideTransition($currentTextSlide, textTransition);

      });
      $textSlideshow.on('change.flickity', function(event, index) {
        $imageSlideshow.flickity('select', index, true, false);
      });
      
      $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');
    },
    initVideo: function(){
      // Selectors
      const $videoElements = this.section.find('[data-video-element]');
      $videoElements.each((key,$videoElement)=>{
        const $playIcon = this.section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
        const $playButton = this.section.find('[data-play-button]');
        const $videoTextContainer = this.section.find('[data-video-text-container]');
        const $imageElement = this.section.find('[data-image-element]');
        const $videoId = $videoElement.getAttribute("data-video-id");
        // Load video if the media has been added
        if (this.iframe_video || this.html5_video) {
          this.loadVideo($videoElement,$videoId, $playIcon, $playButton, $videoTextContainer, $imageElement);
        } else {
          $imageElement.show();
        }
      })
      
      
    },
    loadVideo: function($videoElement,$videoId, $playIcon, $playButton, $videoTextContainer, $imageElement) {
      const player = new Plyr(`.video-${$videoId}`, {
        controls: videoControls,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      player.playerId = $videoId;
      window.videoPlayers.push(player);
      player.muted = this.mute;
      player.ratio = this.aspect_ratio;

      // If autoplay enabled, hide image and text
      if (this.autoplay) {
        player.autoplay = true;
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
      } else {
        // If autoplay disabled, check if poster image added
        if (this.poster) {
          $videoElement.style.display = "none";
          $imageElement.show();
          $videoTextContainer.show();
        } else {
          // If autoplay disabled and no poster image
          $imageElement.hide();
          $videoElement.style.display = "block";
          $videoTextContainer.show();
        }
      }

      // If button exists, clicking button will play video
      if (this.button) {
        $playButton.on('click', (_) =>  {
          let playerId = _.currentTarget.getAttribute("data-player-id");
          for(let vplayer of window.videoPlayers){
            if(`video-${vplayer.playerId}` == playerId){
              vplayer.play();
            }
          }          
        });
      }

      // Clicking anywhere on video should play the video
      if (!this.button) {
        $videoTextContainer.on('click', (_) => {
          player.play();
        })
      }

      // If on mobile and text is below image, clicking the image wrapper should play the video
      if (!isScreenSizeLarge() && $videoElement.closest('.mobile-text--below-media')) {
        $imageElement.on('click', (_) => {
          player.play();
        })
      }

      // On player ready, hide play icon if play button visible
      player.on('ready', function(index, player) {
        if ($playButton && !isScreenSizeLarge() && $videoElement.closest('.mobile-text--below-media')) {
          $playIcon.show();
        } else if ($playButton) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }
      })

      // On play, hide image/text and show video element
      player.on('play', function(index, player) {        
        $videoElement.style.display = "block";
        index.currentTarget.closest(".video-wrapper").querySelector("[data-image-element]").style.display = "none";
        //         $imageElement.hide();
        $videoTextContainer.hide();
      })

      // On player pause, show play icon if play button hidden
      player.on('pause', function(index, player) {
        if (!$playButton) {
          $playIcon.show();
        }
      })

    },
    blockSelect: function($section, blockId) {
      const $slider = $section.find('[data-image-slideshow]');
      const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

      $slider.flickity('select', $sliderIndex, true, true);

      // Resize flickity when the slider is settled
      $slider.on('settle.flickity', function() {
        $slider.flickity('resize');
      }, 500);

    },
    unload: function($section) {
      $section.find('.flickity-button').unwrap();
    }
  }
  /******/
})();